var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5803 4.01195L10.2902 1.72653V1.71654C9.89023 1.31735 9.89023 0.688614 10.2902 0.299397C10.6802 -0.0997992 11.3102 -0.0997992 11.7102 0.299397L15.7102 4.29136C15.9461 4.5207 16.0393 4.84492 15.9899 5.15148C15.9516 5.41804 15.8066 5.65147 15.6 5.80702L11.6995 9.6996C11.5095 9.87924 11.2495 9.98902 10.9895 9.98902L10.9995 10C10.7295 10 10.4695 9.89022 10.2895 9.71058C9.88954 9.32137 9.88954 8.68265 10.2795 8.29344V8.28345L12.5596 6.00793H1C0.44 6.00793 0 5.55883 0 5.00994C0 4.45106 0.44 4.01195 1 4.01195H12.5803Z",
    fill: "#FF8E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowR);
export default __webpack_public_path__ + "static/media/arrowR.c80bfe62e890c03a21e62c6e1868ae19.svg";
export { ForwardRef as ReactComponent };